<template>
	<BaseLayout :include-padding="true" :content-full-height="true" :background-color-class="'mobile-download-page'">
		<template #header>
			<HeaderBasic />
		</template>
		<article class="container text-align-center">
			<h1 class="heading-1" v-html="heading"></h1>
			<div class="grid-md gutters-300-md">
				<div class="col-8-md col-offset-2-md">
					<p v-if="feeWaiver" class="mt-100 mt-200-md mb-150">
						Download our mobile app and sign-up using the
						<strong>same email address</strong> you've entered here.
					</p>
					<p v-else class="mt-100 mt-200-md mb-150">
						Introducing the first simple, low-cost real estate investment&nbsp;platform.
					</p>

					<BaseLink
						:link="{
							href: `${downloadPath}?utm_source=fundrise&utm_campaign=mobile_splash_page&utm_medium=website`
						}"
					>
						<img
							class="download-app-container-image display-inline-block"
							:src="iconPath"
							alt="Download app icon"
						/>
					</BaseLink>

					<p class="mt-100 mt-200-md">
						<BaseLink :link="{ router: `get-started`, target: '_blank' }">
							Continue on mobile browser
						</BaseLink>
					</p>
				</div>
			</div>
		</article>
	</BaseLayout>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { appCloudfrontPath } from '@constants';
import HeaderBasic from '@components/header/header-basic.vue';
import { SupportedMobile } from 'types/mobile';
import { useHead } from '@unhead/vue';
import { useRoute } from 'vue-router';

interface Props {
	mobileType: SupportedMobile;
	iconPath: string;
	downloadPath: string;
}
const props = defineProps<Props>();
const route = useRoute();

const feeWaiver = ref(false);

const heading = computed((): string => {
	return feeWaiver.value
		? 'Join Fundrise and take advantage of your fee waiver.'
		: `Get the Fundrise ${props.mobileType}&nbsp;app`;
});

function setup(): void {
	const pageTitle = `Get the Fundrise ${props.mobileType} App`;
	const metaDescription = `Download the Fundrise app for your ${props.mobileType} device`;
	const backgroundImage = `${appCloudfrontPath}/images/mobilesplashpage-photobckd1.jpg`;

	useHead({
		title: pageTitle,
		meta: [
			{ name: 'description', content: metaDescription },
			{ property: 'og:image', content: backgroundImage }
		]
	});
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const waiver = route.query.feeWaiver as any as boolean;
	feeWaiver.value = waiver;
}

setup();
</script>
<style lang="scss">
.mobile-download-page {
	.page__content-inner {
		background-size: cover;
		background-position: 50% 75%;
		background-image: url($cloud-front-domain + '/images/mobilesplashpage-photobckd1.jpg');
	}

	.download-app-container-image {
		width: 160px;
		height: 54px;
	}
}
</style>
